import React, { useContext } from 'react'
import Cam from '../img/cam.png'
import Add from '../img/add.png'
import More from '../img/more.png'
import ChatMsg from './ChatMsg'
import Input from './Input'
import Chatbot from '../img/chatbot.png'
import { ChatContext } from '../context/ChatContext'
import { AuthContext } from '../context/AuthContext'
const Message = () => {
  const { data } = useContext(ChatContext)
  const {currentuser} = useContext(AuthContext)
   console.log(data.chatId)
   return (
    <div className='message-part'>
      
      {
        !data.user.displayName &&
        <>
             <div className="chatInfo">
        <div className='chat-user-info'>
      <img src={Chatbot} className='user-dp'  />
        <span>vTalk</span>
        </div>
        </div>
        <div className='chat-messages'>
        <div className="conv-message">
     <div className="msginfo">
        <img src= {Chatbot} />
     </div>
     <div className="conv-message msgcontent">
        <p> Hey {currentuser.displayName} </p>
        <p>Welcome to vTalk Web App designed by Varsha</p>
        <p>You can start messaging your friend by searching their name in search box</p> 
        <p>There you go! My work here is done! You're your own boss now!😎😉</p>
      
     </div>
    </div>
    </div>
      <Input />
        </>
      } 
      {
       data.user.displayName &&
      <>
      <div className="chatInfo">
        <div className='chat-user-info'>
      <img src={data.user?.photoURL} className='user-dp'  />
        <span>{data.user?.displayName }</span>
        </div>
        <div className='chatIcons'>
          <img src={Cam} className='mob-no-need'/>
          <img src={Add} className='mob-no-need'/>
          <img src={More } />

        </div>
      


      </div>
      <ChatMsg />
      <Input />
      </>
    }
    </div>
  )
}

export default Message